export const LEGAL_REPRESENTATIVES_ENTITY = 'legalRepresentatives'
export const ULTIMATE_BENEFICIAL_OWNERS_ENTITY = 'ultimateBeneficialOwners'
